var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23C2 11.402 11.402 2 23 2C34.598 2 44 11.402 44 23C44 34.598 34.598 44 23 44C11.402 44 2 34.598 2 23Z",
    fill: "#DAEDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26V28H21C21 28.7956 20.6839 29.5587 20.1213 30.1213C19.5587 30.6839 18.7956 31 18 31C17.2044 31 16.4413 30.6839 15.8787 30.1213C15.3161 29.5587 15 28.7956 15 28H13V17C13 16.4696 13.2107 15.9609 13.5858 15.5858C13.9609 15.2107 14.4696 15 15 15H28C28.5304 15 29.0391 15.2107 29.4142 15.5858C29.7893 15.9609 30 16.4696 30 17V26H33ZM18 27C17.7348 27 17.4804 27.1054 17.2929 27.2929C17.1054 27.4804 17 27.7348 17 28C17 28.2652 17.1054 28.5196 17.2929 28.7071C17.4804 28.8946 17.7348 29 18 29C18.2652 29 18.5196 28.8946 18.7071 28.7071C18.8946 28.5196 19 28.2652 19 28C19 27.7348 18.8946 27.4804 18.7071 27.2929C18.5196 27.1054 18.2652 27 18 27Z",
    fill: "#165AE3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 43.4856L23.6274 51.4616C23.2607 51.7579 22.737 51.7578 22.3704 51.4616L12.5 43.4854L33.5 43.4856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckMarker);
export default __webpack_public_path__ + "static/media/truck-marker.ecf02d180447e6507cb82f9485722a02.svg";
export { ForwardRef as ReactComponent };